import { render, staticRenderFns } from "./AmazonReview.vue?vue&type=template&id=5a9b9bb8&scoped=true&"
import script from "./AmazonReview.vue?vue&type=script&lang=js&"
export * from "./AmazonReview.vue?vue&type=script&lang=js&"
import style0 from "./AmazonReview.vue?vue&type=style&index=0&id=5a9b9bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9b9bb8",
  null
  
)

export default component.exports